import React, { useState } from 'react';
import { Copy, Link2 } from 'lucide-react';
import { getIntegrationApiBaseUrl, getShipmentsApiCreateUrl } from '../utils/integrationApiBase';

export const IntegrationApiBaseBanner: React.FC = () => {
  const base = getIntegrationApiBaseUrl();
  const createUrl = getShipmentsApiCreateUrl();
  const [copied, setCopied] = useState<'base' | 'create' | null>(null);

  const copy = (which: 'base' | 'create', text: string) => {
    void navigator.clipboard.writeText(text);
    setCopied(which);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div
      className="card"
      style={{
        marginBottom: 20,
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
        border: '1px solid #7dd3fc',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <Link2 size={22} color="#0369a1" style={{ flexShrink: 0, marginTop: 2 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, color: '#0c4a6e', marginBottom: 6 }}>Integration base URL (for your developers)</div>
          <p style={{ fontSize: 13, color: '#075985', margin: '0 0 12px', lineHeight: 1.5 }}>
            HTTP clients must call this <strong>API host</strong> (HTTPS + <code style={{ fontSize: 12 }}>/api/v1</code>),{' '}
            <strong>not</strong> the marketing website (<code style={{ fontSize: 12 }}>www</code> / homepage). Posting to the wrong host returns HTML or 405.
          </p>
          <div style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 11, color: '#0369a1', fontWeight: 600, marginBottom: 4 }}>API base</div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <code
                style={{
                  fontSize: 12,
                  background: '#fff',
                  padding: '8px 10px',
                  borderRadius: 6,
                  border: '1px solid #bae6fd',
                  wordBreak: 'break-all',
                  flex: 1,
                  minWidth: 200,
                }}
              >
                {base}
              </code>
              <button type="button" className="btn btn-ghost" style={{ padding: '6px 10px', fontSize: 12 }} onClick={() => copy('base', base)}>
                <Copy size={14} /> {copied === 'base' ? 'Copied' : 'Copy'}
              </button>
            </div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#0369a1', fontWeight: 600, marginBottom: 4 }}>Create shipment (example)</div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <code
                style={{
                  fontSize: 11,
                  background: '#fff',
                  padding: '8px 10px',
                  borderRadius: 6,
                  border: '1px solid #bae6fd',
                  wordBreak: 'break-all',
                  flex: 1,
                  minWidth: 200,
                }}
              >
                POST {createUrl}
              </code>
              <button type="button" className="btn btn-ghost" style={{ padding: '6px 10px', fontSize: 12 }} onClick={() => copy('create', createUrl)}>
                <Copy size={14} /> {copied === 'create' ? 'Copied' : 'Copy'}
              </button>
            </div>
          </div>
          {process.env.REACT_APP_INTEGRATION_API_BASE_URL && (
            <p style={{ fontSize: 11, color: '#64748b', margin: '10px 0 0' }}>
              Shown from <code>REACT_APP_INTEGRATION_API_BASE_URL</code> (overrides <code>REACT_APP_API_URL</code> for this panel).
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
